import Keycloak from 'keycloak-js';

let keycloak = null;

export function initKeycloak(config) {
  keycloak = new Keycloak(config);
  return keycloak;
}

export function getKeycloak() {
  return keycloak;
}